<template>
    <div class="start-modal">
        <el-dialog v-model="modelValueState" @closed="$emit('closed')" :show-close="false">
            <template #header>
                <div>
                    <img :src="$config.header_logo_url">
                </div>
                <CloseModalButton @click="modelValueState = false" />
            </template>
            <template v-if="successMessage">
                <el-row>
                    <div class="success-wrapper">{{ successMessage }}</div>
                </el-row>
            </template>
            <template v-else>
                <el-row>
                    <el-col :span="24" class="title-col">
                        <div>{{ $trans('web_search.checkout_start_modal.modal_title') }}</div>
                    </el-col>
                </el-row>
                <el-row class="start-modal-content">
                    <el-col>
                        <el-form ref="formRef" label-position="top" label-width="100px" :model="formData" :rules="rules"
                            :show-message="true" :validate-on-rule-change="false" require-asterisk-position="right">
                            <el-form-item :label="$trans('web_search.checkout_fields.board_name')" required
                                prop="board_name" autocomplete="off">
                                <el-input v-model="formData.board_name" />
                            </el-form-item>
                            <el-form-item v-if="$user == undefined" :label="$trans('web_search.checkout_fields.email')"
                                required prop="email" autocomplete="off">
                                <el-input v-model="formData.email" @input="canSubmit = true" />
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col>
                        <StartModalSide />
                    </el-col>
                    <el-col :span="24" class="center">
                        <div class="error-wrapper" v-if="message" style="margin-bottom: 20px;">
                            {{ message }}
                        </div>
                        <el-button v-if="canSubmit && CandidateBoardStore.getProfileCount()" :loading="isSubmitting" @click="onSubmit()" :id="searchButtonId">
                            {{ $trans('web_search.checkout_start_modal.button') }}
                        </el-button>
                        <el-button v-else type="info" disabled>
                            {{ $trans('web_search.checkout_start_modal.button') }}
                        </el-button>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" class="title-col">
                        <div>{{ $trans('web_search.checkout_start_modal.your_selection_of_candidates') }}</div>
                    </el-col>
                </el-row>
                <el-row class="your-selection-content">
                    <el-col>
                        <div class="tag-header">
                            <span class="color-grey">{{ $trans('web_search.add_to_board_modal.search_terms') }}</span>
                        </div>
                        <div class="match-rate-header">
                            <span class="color-grey">Match Rate</span>
                        </div>
                        <div v-for="(profile, index) in CandidateBoardStore.getProfiles()" :key="index"
                            class="your-selection-row">
                            <div>
                                <img :src="profile.avatar_url">
                            </div>
                            <div>
                                <template v-for="(filter, index) in profile.activeTerms" :key="index">
                                    <Tag size="small" :text="filter.name" />
                                </template>
                                <template v-for="(filter, index) in profile.activeFilters" :key="index">
                                    <Tag size="small" :text="filter" />
                                </template>
                            </div>
                            <div class="match-rate">
                                <div>
                                    <span class="color-black">{{ profile.percentage_score_avg }}</span>
                                    <span class="color-grey"> / 100</span>
                                </div>
                            </div>
                            <div class="action">
                                <el-icon color="white" @click="CandidateBoardStore.removeFromBoard(profile.id)">
                                    <DeleteIcon />
                                </el-icon>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import { Delete as DeleteIcon } from '@element-plus/icons-vue';
import CloseModalButton from './CloseModalButton';
import StartModalSide from './StartModalSide';
import Tag from './../Utils/Tag';
import { mapStores } from 'pinia';
import { useCandidateBoardStore } from '@/stores/CandidateBoardStore';

export default {
    props: ['modelValue', 'groupName'],
    emits: ['update:modelValue', 'validated', 'closed'],
    components: {
        CloseModalButton,
        StartModalSide,
        DeleteIcon,
        Tag,
    },
    data() {
        return {
            isSubmitting: false,
            modelValueState: false,
            message: false,
            successMessage: false,
            formData: {
                board_name: '',
                email: '',
            },
            rules: {
                board_name: [
                    { required: true, message: this.$trans('web_search.checkout_field_errors.required'), trigger: 'blur' },
                ],
                email: [
                    { required: (this.$user == undefined), message: this.$trans('web_search.checkout_field_errors.required'), trigger: 'blur' },
                ],
            },
            canSubmit: (!this.$user || this.$user.is_client == true),
        };
    },
    computed: {
        ...mapStores(useCandidateBoardStore),
        searchButtonId() {
            switch (this.groupName) {
                case 'Deutsche Interim AG':
                    return 'di_create_candidateboard';
                case 'Swiss Interim GmbH':
                    return 'si_create_candidateboard';
                case 'Matchmaker':
                    return 'mm_create_candidateboard';
                default:
                    return 'di_create_candidateboard';
            }
        },
    },
    methods: {
        async onSubmit() {
            if (this.isSubmitting) return;

            var self = this;

            if (this.$user == undefined) {
                await this.$refs.formRef.validate((valid, fields) => {
                    if (valid) {
                        self.isSubmitting = true;
                        let data = {
                            formData: {
                                board_name: this.formData.board_name,
                                email: this.formData.email,
                            }
                        };
                        const validateEmail = this.ajaxValidateEmail();

                        validateEmail.then(function (result) {
                            self.isSubmitting = false;

                            if (result.status == 'success' && result.data) {
                                if (result.data.email_status == 'registered') {
                                    if (result.data.email_is_client == true) {
                                        data.nextModal = 'LoginModal';
                                        self.$emit('validated', data);
                                        return;
                                    }
                                } else {
                                    data.nextModal = 'RegisterModal';
                                    self.$emit('validated', data);
                                    return;
                                }
                            }

                            if (result.status == 'error') {
                                self.message = result.message;
                                self.canSubmit = false;
                            }
                        }).catch(function() {
                            self.isSubmitting = false;
                        });
                    }
                });
            } else {
                await this.$refs.formRef.validate((valid, fields) => {
                    if (valid) {
                        self.isSubmitting = true;
                        const createVacancy = this.ajaxCreateVacancy();

                        createVacancy.then(function (result) {
                            if (result.status == 'success') {
                                self.redirectAfterCreateVacancy();
                            } else {
                                self.message = result.message;
                                self.canSubmit = false;
                                self.isSubmitting = false;
                            }
                        }).catch(function() {
                            self.isSubmitting = false;
                        });
                    }
                });
            }
        },
        async ajaxCreateVacancy() {
            const response = await fetch('/api/web-search/create-vacancy', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    vacancy_name: this.formData.board_name,
                    vacancy_managers: this.CandidateBoardStore.getProfileIds(),
                    vacancy_manager_criterias: this.CandidateBoardStore.getProfileCriterias(),
                    _token: document.head.querySelector('meta[name="csrf-token"]').content,
                })
            });

            return await response.json();
        },
        async ajaxValidateEmail() {
            const response = await fetch('/api/web-search/validate-email', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: this.formData.email,
                    _token: document.head.querySelector('meta[name="csrf-token"]').content,
                })
            });

            return await response.json();
        },
        generatePresetBoardName() {
            let terms = window.document.querySelector('input[name="terms"]').value;
            let datetime = this.$moment().format('DD.MM.YYYY HH:MM');

            return terms + ' ' + datetime;
        },
        redirectAfterCreateVacancy() {
            let delay = 5000;
            this.successMessage = this.$trans('web_search.checkout_response_messages.success_please_wait_to_redirecting');

            setTimeout(function () {
                window.location = '/';
            }, delay);
        },
    },
    watch: {
        modelValue: function () {
            this.modelValueState = this.modelValue;
            this.message = false;
            this.isSubmitting = false;
            if (!this.formData.board_name) {
                this.formData.board_name = this.generatePresetBoardName();
            }
            if (!this.canSubmit) {
                this.message = this.$trans('web_search.checkout_response_messages.you_dont_have_access_please_contact_with_administrator').replace(':email', this.$config.company_email);
            }
        },
    }
}
</script>

<style scoped>
.start-modal :deep(.el-dialog) {
    --el-dialog-width: 800px;
    top: -100px !important;
}

.center {
    text-align: center;
}

.success-wrapper {
    color: #81BC8F;
    text-align: center;
    font-weight: bold;
    width: 100%;
}

.error-wrapper {
    color: #FF6B65;
    font-style: italic;
}

.start-modal :deep(.el-dialog .el-dialog__header) {
    padding-bottom: 0;
}

.start-modal :deep(.el-form--default.el-form--label-top .el-form-item .el-form-item__label) {
    margin-bottom: 0px;
}

.start-modal .el-row {
    background-color: #ededed;
    color: rgb(60, 60, 60);
    padding-bottom: 18px;
}

.start-modal .el-row:first-child {
    padding-top: 18px;
}

.start-modal .el-row:nth-child(3) {
    margin-top: 20px;
    padding-top: 18px;
}

.start-modal .el-col {
    padding: 0 15px;
}

.start-modal .title-col div {
    text-align: left;
    font: normal normal 500 24px/29px Barlow;
    letter-spacing: -0.24px;
    color: #3C3C3C;
    padding-top: 4px;
    padding-bottom: 4px;
    border-bottom: 1px solid rgb(60, 60, 60);
}

.start-modal-content>div:nth-child(1) {
    max-width: 60%;
    flex: 0 0 60%;
}

.start-modal-content>div:nth-child(2) {
    max-width: 40%;
    flex: 0 0 40%;
}

.start-modal .el-button {
    border-radius: 4px;
    height: 40px;
    width: 100%;
    max-width: 600px;
    font-size: 18px;
    font-weight: 300;
}

.start-modal .el-button:not(.el-button--info) {
    background-color: #41ABC4;
    color: #fff;
}

.start-modal .el-button:not(.el-button--info):hover {
    background-color: #2699b2;
}

.your-selection-content {
    display: block;
    max-height: 300px;
    overflow-y: auto;
}

.your-selection-row {
    display: flex;
    padding: 8px 16px;
}

.your-selection-row:not(:last-child) {
    padding-bottom: 4px;
    border-bottom: 1px solid rgb(60, 60, 60);
}

.your-selection-row>div:nth-child(1)>img {
    width: 80px;
    height: 80px;
    border-radius: 50%;
}

.your-selection-row>div:nth-child(2) {
    flex-grow: 1;
    padding: 5px 15px;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    overflow-y: hidden;
}

.your-selection-row>div:nth-child(4) {
    display: flex;
    align-items: center;
}

.your-selection-row>div:nth-child(4):first-child {
    margin-top: -55px;
}

.your-selection-row>div:nth-child(4)>.el-icon {
    background-color: #41ABC4;
    padding: 10px;
    width: 22px;
    height: 22px;
    border-radius: 10px;
    background-image: linear-gradient(#ff6b65 0 0);
    background-size: 100% .0em;
    background-repeat: no-repeat;
    transition: 0.1s;
}

.your-selection-row>div:nth-child(4)>.el-icon:hover {
    transition: 0.1s;
    background-size: 100% 100%;
    cursor: pointer;
}

.your-selection-row>div:nth-child(4)>.el-icon>svg {
    width: 22px;
    height: 22px;
}

.match-rate {
    font-size: 20px;
    min-width: 120px;
}

.tag-header {
    margin-left: 113px;
    font-weight: bold;
    font-size: 18px;
}

.match-rate-header {
    margin-left: 558px;
    bottom: 25px;
    position: relative;
    font-weight: bold;
    font-size: 18px;
}

@media only screen and (max-width: 500px) {
    .your-selection-content {
        max-height: unset;
    }

    .your-selection-row {
        justify-content: space-between;
        flex-wrap: wrap;
    }

    .your-selection-row>div:nth-child(2) {
        order: 3;
        padding: 10px 0;
        width: 100%;
    }
}

/* max-wdith = width of modal + 50px */
@media only screen and (max-width: 850px) {
    .el-dialog {
        position: fixed;
        z-index: 100;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        border-radius: 8px;
        width: calc(100% - 30px);
        margin: 15px;
        box-sizing: border-box;
        overflow-y: scroll;
    }

    .start-modal :deep(.el-dialog) {
        --el-dialog-width: 95%;
    }

    .start-modal-content>div:nth-child(1) {
        max-width: 100%;
        flex: 0 0 100%;
    }

    .start-modal-content>div:nth-child(2) {
        display: none;
    }
}

@media only screen and (max-width: 790px) {
    .match-rate-header {
        margin-left: unset;
        bottom: 27px;
    }

    .tag-header .color-grey {
        margin-left: -108px;
    }

    .match-rate-header .color-grey {
        margin-left: 44%;
    }

    .match-rate {
        min-width: 75px;
    }
}
</style>
